import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'LeaguePlayer';

const LeaguePlayerApi: any = baseApi(endpoint);

export default LeaguePlayerApi;